import React from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import MDProgress from 'react-md-progress-bar';
import PropTypes from 'prop-types';
import _ from 'lodash';

export default class Confirm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpened : false,
            cancelText: props.cancelText || "Cancel",
            confirmText: props.confirmText || "Confirm",
        };

        this.onToggle = this.toggle.bind(this);
        this.confirm = this.onConfirm.bind(this);
        this._isMounted = false;
    }

    toggle() {

        const state = !this.state.isOpened;
        if(!state && this.props.isBusy){
            return;
        }

        this.setStateSafe({
            isOpened: state
        });
    }

    setStateSafe(state){

        if(this._isMounted)
            this.setState(state);
    }

    componentWillMount(){
        this._isMounted = true;
    }

    componentWillUnmount(){
        this._isMounted = false;
    }


    async onConfirm() {

        //  confirm now
        if(_.isFunction(this.props.onConfirm)) {

            try {
                await this.props.onConfirm();
            }
            catch (e) {
                //  continue with exceptions
            }
        }

        this.setStateSafe({
            isOpened: false,
        });
    }

    show(){

        this.setStateSafe({
            isOpened: true,
        });
    }


    render() {

        const props = this.props;
        const cancelButton = this.props.cancelText ?
            (<Button style={{borderRadius: 4}} onClick={this.onToggle}>{this.props.cancelText}</Button>) : null;
        return (
            <Modal isOpen={this.state.isOpened} toggle={this.onToggle} contentClassName="modal-default-padding">
                <ModalHeader toggle={this.onClose}>
                    {this.props.title}
                </ModalHeader>
                <ModalBody>

                    <div style={{padding: 5}}>
                        {this.props.body}
                    </div>

                    {props.isBusy && <MDProgress show={true} overlay={true}/>}
                </ModalBody>
                <ModalFooter>
                    {cancelButton}
                    <Button style={{borderRadius: 4}}  color={this.props.confirmBtnColor} onClick={this.confirm}>{this.props.confirmText}</Button>
                </ModalFooter>
            </Modal>
        );

    }
}

Confirm.propTypes = {
    body: PropTypes.any,
    cancelText: PropTypes.string,
    confirmBtnColor: PropTypes.string,
    confirmText: PropTypes.string,
    onConfirm: PropTypes.func,
    title: PropTypes.string,
    onCancel: PropTypes.func,
    isBusy: PropTypes.bool
};

Confirm.defaultProps = {
    cancelText: 'Cancel',
    confirmText: 'Confirm',
    confirmBtnColor: 'success',
    showCancelButton: true
};




// WEBPACK FOOTER //
// ./src/components/Confirm/Confirm.js